// Auto-generate a fallback SKU when the user leaves the field blank.
// SKU is optional on the product forms, but the backend still requires a
// non-empty, unique value — so we derive one from the product name plus a
// short random suffix (mirrors the barcode quick-add's `QA-…` scheme).
export function generateSku(name: string): string {
  const slug = name
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 12);
  const suffix = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `${slug || 'PRD'}-${suffix}`;
}
